import { createSlice } from '@reduxjs/toolkit';
import { createIndependentStore } from '@utils/react';

const initialState = {
  sortedBy: "lexicographic"
};
const slice = createSlice({
  name: "user-area/portals",
  initialState,
  reducers: {
    sort(state, action) {
      state.sortedBy = action.payload;
    }
  }
});
const portalsStore = createIndependentStore(slice);

export { portalsStore };
//# sourceMappingURL=state.store.js.map
